import { FORWARDED_PARAM_KEYS } from 'lib/analytics/forwardedParams';
import {
  LANDING_PARAM_KEYS,
  rememberLandingParams,
  type LandingParamKey,
} from 'lib/analytics/landingParams';

/** Full page URL for utm_source, e.g. `www.ultrahuman.com/in/performance-lab/recovery/`. */
export function getPageUrlUtmSource(fallback = 'performance-lab'): string {
  if (typeof window === 'undefined') return fallback;
  return `${window.location.hostname}${window.location.pathname}`;
}

const CLICK_ID_KEYS = new Set<string>(['gclid', 'fbclid']);
const LANDING_KEYS = new Set<string>(LANDING_PARAM_KEYS);

/**
 * Builds the `tracking` object for `@typeform/embed` Widget.
 * Current URL wins, then the landing session, then `defaults`.
 * The page-address fallback only applies when both of those are empty.
 * Click ids are not tracking fields. They go through the embed's hidden props.
 */
export function buildTypeformTrackingFromUrl(
  defaults: Record<string, string>,
): Record<string, string> {
  if (typeof window === 'undefined') {
    return { ...defaults };
  }

  const stored = rememberLandingParams(window.location.search ?? '');
  const params = new URLSearchParams(window.location.search ?? '');
  const forwarded = new Set<string>(FORWARDED_PARAM_KEYS);
  const keys = new Set<string>([
    ...FORWARDED_PARAM_KEYS,
    ...Object.keys(defaults),
  ]);
  const out: Record<string, string> = {};

  for (const key of keys) {
    if (CLICK_ID_KEYS.has(key)) continue;
    const fromUrl = forwarded.has(key) ? params.get(key) ?? '' : '';
    const fromLanding = LANDING_KEYS.has(key)
      ? stored[key as LandingParamKey] ?? ''
      : '';
    const value = fromUrl || fromLanding || defaults[key] || '';
    if (value) out[key] = value;
  }

  return out;
}
